import axios from 'axios'
import Bus from '@/assets/js/vueBus'
import toTipsObj from './toTipsObj.js'
import Vue from 'vue'
import $store from '@/store.js'
import { environmentTable } from '@/assets/js/environmentTable'
import { resolve } from '@sentry/utils'
window.utilVue = new Vue()
// import $store from "@/store.js";

const Tool = {
  getByteLength (str) {
    if (str) {
      let totalLength = 0
      for (var i = 0; i < str.length; i++) {
        var charCode = str.charCodeAt(i)
        if (charCode < 0x007f) {
          totalLength++
        } else if ((charCode >= 0x0080) && (charCode <= 0x07ff)) {
          totalLength += 2
        } else if ((charCode >= 0x0800) && (charCode <= 0xffff)) {
          totalLength += 3
        } else {
          totalLength += 4
        }
      }
      return totalLength
    } else {
      return 0
    }
  },
  // 偏移量时间转换
  changgeformatSeconds (i, name) {
    const second = Number(i)
    const flag = String(second).indexOf('.') + 1
    let decimal = '00'
    if (flag > 0) {
      decimal = Math.floor(second * 29.97 - parseInt(second) * 29.97)
      if (decimal < 10) {
        decimal = `0${decimal}`
      }
    }

    let s = parseInt(second) // 需要转换的时间秒
    let m = 0 // 分
    let h = 0 // 小时
    if (s > 60) {
      m = parseInt(s / 60)
      s = parseInt(s % 60)
      if (m > 60) {
        h = parseInt(m / 60)
        m = parseInt(m % 60)
      }
    }

    let ss,
      mm,
      hh
    if (s > 0) {
      ss =
        s.toString().length >= 2
          ? s.toString()
          : `0${s.toString()}`
    } else {
      ss = '00'
    }

    if (m > 0) {
      mm =
        m.toString().length >= 2
          ? m.toString()
          : `0${m.toString()}`
    } else {
      mm = '00'
    }

    if (h > 0) {
      hh =
        h.toString().length >= 2
          ? h.toString()
          : `0${h.toString()}`
    } else {
      hh = '00'
    }
    const result = `${hh}:${mm}:${ss}:${decimal}`
    if (result == '00:00:00:00' && name && this.FileNameSuffix(name) == 'json') {
      return window.VueTwo.$t('lang.InRecording')
    }
    return result
  },
  // 偏移量时间转换
  formatSecondsChange (time) {
    let flag = '+'
    if (time < 0) {
      flag = '-'
    }
    const i = Math.abs(time)
    const second = Number(i)
    let s = parseInt(second) // 需要转换的时间秒
    let m = 0 // 分
    let h = 0 // 小时
    if (s >= 60) {
      m = parseInt(s / 60)
      s = parseInt(s % 60)
      if (m >= 60) {
        h = parseInt(m / 60)
        m = parseInt(m % 60)
      }
    }

    let ss,
      mm,
      hh
    if (s > 0) {
      ss =
        s.toString().length >= 2
          ? s.toString()
          : `0${s.toString()}`
    } else {
      ss = '00'
    }

    if (m > 0) {
      mm =
        m.toString().length >= 2
          ? m.toString()
          : `0${m.toString()}`
    } else {
      mm = '00'
    }

    if (h > 0) {
      hh =
        h.toString().length >= 2
          ? h.toString()
          : `0${h.toString()}`
    } else {
      hh = '00'
    }
    const result = `${flag} ${hh}:${mm}:${ss}`
    return result
  },
  // 判断manager权限
  getManager (result) {
    const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
    const { playoutServerName } = urlInfo
    window.VueTwo.$getUserAuth({
      ...window.VueTwo.$TVU, // 参考开发手册设置的全局配置
      params: { // 请求接口所需要的参数
        showAllPermission: true, // true:显示该服务下所有的permission列表，不论是否有开启权限。false：只显示有权限的permission列表
        serviceNameList: [playoutServerName] // 各个服务具体传参参数咨询chris
      },
      success: (val) => { // 接口成功的回调，返回result
        if (val[0] && val[0].permissionList && val[0].permissionList.length > 0) {
          const permissionList = val[0].permissionList
          result(permissionList)
        }
      },
      error: (val) => { // 接口失败的回调，会包含失败的状态码
        result('error')
        console.log(val)
      }
    })
  },
  // 获取session
  getEnvironment () {
    let environment = ''
    const cookieArr = document.cookie.split(';')
    for (const v of cookieArr) {
      if (
        environmentTable[v.split('=')[0].toLowerCase().trim()]
      ) {
        environment = environmentTable[v.split('=')[0].toLowerCase().trim()]
        break
      }
    }
    return environment
  },
  // 获取持续时间
  getDuration (leftTime) {
    if (leftTime >= 0) {
      const d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
      const h = Math.floor(leftTime / 1000 / 60 / 60 % 24) >= 10 ? Math.floor(leftTime / 1000 / 60 / 60 % 24) : `0${Math.floor(leftTime / 1000 / 60 / 60 % 24)}`
      const m = Math.floor(leftTime / 1000 / 60 % 60) >= 10 ? Math.floor(leftTime / 1000 / 60 % 60) : `0${Math.floor(leftTime / 1000 / 60 % 60)}`
      const s = Math.floor(leftTime / 1000 % 60) >= 10 ? Math.floor(leftTime / 1000 % 60) : `0${Math.floor(leftTime / 1000 % 60)}`

      return `${h}:${m}:${s}`
    }
  },
  // 获取feature列表
  getWeek () {
    var time = new Date()
    var timesStamp = time.getTime()
    var currenDay = time.getDay()
    var weekDates = []

    for (var i = 0; i < 7; i++) {
      weekDates.push(new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString()
        .replace(/\//g, '-'))
    }
    weekDates = weekDates.map(v => {
      return new Date(Date.parse(v.replace(/-/g, '/')))
    })
    return weekDates
  },
  TransitionCurrentTime2 (time) {
    let type = ''
    const y = time.getFullYear()
    let hour = time.getHours()
    let min = time.getMinutes()
    let s = time.getSeconds()
    const TimeFormat = this.getDateTimeFormat()
    if (TimeFormat.broadcastTimeFormat) {
      hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
    } else {
      if (hour >= 0 && hour <= 11) {
        type = 'AM'
        hour = hour == 0 ? 12 : hour
      } else {
        type = 'PM'
        hour = hour == 12 ? hour : hour - 12
      }
    }
    min = min >= 0 && min < 10 ? `0${min}` : min
    s = s >= 0 && s < 10 ? `0${s}` : s
    let mon
    if (time.getMonth() + 1 >= 10) {
      mon = time.getMonth() + 1
    } else {
      mon = `0${time.getMonth() + 1}`
    }
    let d
    if (time.getDate() >= 10) {
      d = time.getDate()
    } else {
      d = `0${time.getDate()}`
    }
    return `${hour}:${min}:${s} ${type}`
  },
  TransitionCurrentTime1 (time) {
    let type = ''
    const y = time.getFullYear()
    let hour = time.getHours()
    let min = time.getMinutes()
    let s = time.getSeconds()
    const TimeFormat = this.getDateTimeFormat()
    if (TimeFormat.broadcastTimeFormat) {
      hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
    } else {
      if (hour >= 0 && hour <= 11) {
        type = 'AM'
        hour = hour == 0 ? 12 : hour
      } else {
        type = 'PM'
        hour = hour == 12 ? hour : hour - 12
      }
    }
    min = min >= 0 && min < 10 ? `0${min}` : min
    s = s >= 0 && s < 10 ? `0${s}` : s
    let mon
    if (time.getMonth() + 1 >= 10) {
      mon = time.getMonth() + 1
    } else {
      mon = `0${time.getMonth() + 1}`
    }
    let d
    if (time.getDate() >= 10) {
      d = time.getDate()
    } else {
      d = `0${time.getDate()}`
    }
    return `${y}-${mon}-${d} ${hour}:${min}:${s} ${type}`
  },
  async getFeatureList (programId, userId) {
    let featureList = []
    await axios
      .post(this.getUrl('/program/listFeatures'), { programId, userId })
      .then((res) => {
        if (res.data.errorCode == '0x0') {
          localStorage.setItem('listFeature', res.data.result)
          featureList = res.data.result
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    return featureList
  },
  getJsonMessage (item, region, userId) {
    return axios.post(
      '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/parseFileInfoData',
      {
        url: item.url,
        fileId: item.id,
        region: region,
        userId: userId
      }
    )
  },
  // 获取间隙时间
  async getEventGap (startTime) {
    const programId = this.getProgramReceiver() && this.getProgramReceiver().ProgramId
    const currentTime = startTime
    let GapTime = {}
    if (!programId) return
    if (!startTime) return GapTime
    await axios({
      method: 'post',
      url: this.getUrl('/event/getGap'),
      data: { currentTime, programId },
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then((res) => {
      if (res.data.errorCode == '0x0') {
        GapTime = res.data.result
      }
    }).catch(() => {
    })
    return GapTime
  },
  // 获取日期时间选择框格式
  getDateTimePickerFormat (type) {
    // type : 默认{} 'date'日期  'time'时间
    const Format = this.getDateTimeFormat()
    const DateFormat = {
      0: 'yyyy-MM-dd',
      1: 'MM-dd-yyyy',
      2: 'dd-MM-yyyy'
    }
    const TimeFormat = {
      0: 'h:mm:ss A',
      1: 'H:mm:ss'
    }
    const PickerFormat = {}
    if (Format.broadcastDateFormat) {
      PickerFormat.Date = DateFormat[Format.broadcastDateFormat]
    } else {
      PickerFormat.Date = DateFormat[0]
    }
    if (Format.broadcastTimeFormat) {
      PickerFormat.Time = TimeFormat[Format.broadcastTimeFormat]
    } else {
      PickerFormat.Time = TimeFormat[0]
    }
    PickerFormat.DateTime = PickerFormat.Date + ' ' + PickerFormat.Time
    if (type == 'date') {
      return PickerFormat.Date
    } else if (type == 'time') {
      return PickerFormat.Time
    } else {
      return PickerFormat
    }
  },
  // 获取日期时间格式
  getDateTimeFormat () {
    // broadcastTimeFormat 1: 24小时 0：12小时
    // broadcastDateFormat
    let ProgramRMessage = sessionStorage.getItem('ProgramRMessage')
    if (ProgramRMessage) {
      ProgramRMessage = JSON.parse(ProgramRMessage)
      return {
        broadcastDateFormat: ProgramRMessage.broadcastDateFormat,
        broadcastTimeFormat: ProgramRMessage.broadcastTimeFormat
      }
    } else {
      return {}
    }
  },
  // 获取program信息及R的信息
  getProgramReceiver (key) {
    let ProgramRMessage = sessionStorage.getItem('ProgramRMessage')
    if (ProgramRMessage) {
      ProgramRMessage = JSON.parse(ProgramRMessage)
      if (key) {
        return ProgramRMessage[key]
      } else {
        return ProgramRMessage
      }
    } else {
      return false
    }
  },
  // 获取文件的后缀名
  FileNameSuffix (name) {
    // /获取最后一个.的位置
    const index = name.lastIndexOf('.')
    // 获取后缀
    const ext = name.substr(index + 1)
    // 输出结果
    return ext
  },
  // 计算houseID
  ComputeHouseID (name) {
    if (typeof name == 'string') {
      name = name.substring(0, 4)
    }
    const NewDateObiect = this.getDateTime()
    name = name || ''
    return `${name}-${NewDateObiect.month}${NewDateObiect.day}${
      NewDateObiect.year
    }-${NewDateObiect.hour}${NewDateObiect.min}${NewDateObiect.s}`
  },
  TransitionCurrentTime (time) {
    let type = ''
    const y = time.getFullYear()
    const mon = time.getMonth() + 1
    const d = time.getDate()
    let hour = time.getHours()
    let min = time.getMinutes()
    let s = time.getSeconds()
    const TimeFormat = this.getDateTimeFormat()
    if (TimeFormat.broadcastTimeFormat) {
      hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
    } else {
      if (hour >= 0 && hour <= 11) {
        type = 'AM'
        hour = hour == 0 ? 12 : hour
      } else {
        type = 'PM'
        hour = hour == 12 ? hour : hour - 12
      }
    }
    min = min >= 0 && min < 10 ? `0${min}` : min
    s = s >= 0 && s < 10 ? `0${s}` : s
    return `${y}-${mon}-${d} ${hour}:${min}:${s} ${type}`
  },
  changeTime (date) {
    if (date != null) {
      const time = new Date(date * 1000)
      Date.prototype.toLocaleString = function () {
        return `${this.getFullYear()}/${this.getMonth() +
          1}/${this.getDate()} ${this.getHours()}:${this.getMinutes()}:${this.getSeconds()}`
      }
      return time.toLocaleString()
    } else {
      return null
    }
  },
  changeDateToStr (ts, index) {
    const dateVal = this.changeDate(ts, 0)
    let newDate = ''
    if (index == 'e') {
      newDate = `${dateVal} 23:59:59`
    } else {
      newDate = `${dateVal} 00:00:00`
    }
    return new Date(newDate).getTime()
  },
  changeDate (ts, num) {
    const oneDay = 1000 * 60 * 60 * 24
    const dateStr = new Date(ts + oneDay * num - 0)
    const y = dateStr.getFullYear()
    const mon = dateStr.getMonth() + 1
    const d = dateStr.getDate()
    return `${mon}/${d}/${y}`
  },
  MillisecondToDate (msd) {
    // 获取时分秒 msd 单位:s
    var time = parseFloat(msd)
    if (time != null && time != '') {
      if (time > 60 && time < 60 * 60) {
        time = `00:${parseInt(time / 60.0)}:${parseInt(
          (parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60
        )}`
      } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
        time = `${parseInt(time / 3600.0)}:${parseInt(
          (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
        )}:${parseInt(
          (parseFloat(
            (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
          ) -
            parseInt(
              (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
            )) *
            60
        )}`
      } else {
        time = `00:00:${parseInt(time)}`
      }
    }
    return time
  },
  changeNewTime (ts) {
    var dateStr = new Date(ts - 0) // 1453161600000
    var h = dateStr.getHours()
    h = h < 10 ? `0${h}` : h
    var min = dateStr.getMinutes()
    min = min < 10 ? `0${min}` : min
    var s = dateStr.getSeconds()
    s = s < 10 ? `0${s}` : s
    return `${h}:${min}:${s}`
  },
  changeNewDate (ts, type) {
    const dateStr = new Date(ts - 0)
    const y = dateStr.getFullYear()
    let mon = dateStr.getMonth() + 1
    mon = mon < 10 ? `0${mon}` : mon
    let d = dateStr.getDate()
    d = d < 10 ? `0${d}` : d
    if (type) {
      return `${y}/${mon}/${d}`
    }
    return `${y}-${mon}-${d}`
  },
  CompareTime (timeList) {
    const newTimeList = timeList.sort(this.compareDate)
    return newTimeList
  },
  tagList (array) {
    let str = ''
    if (array.length > 0) {
      for (var i = 0; i < array.length; i++) {
        str += `${array[i]},`
      }
    }
    return str.substring(0, str.length - 1)
  },
  size (data, key) {
    switch (key) {
      case 'MB':
        return `${(data / 1024 / 1024).toFixed(1)}MB`
      case 'GB':
        return `${(data / 1024 / 1024 / 1024).toFixed(1)}GB`
      default:
        break
    }
  },
  returnFindIndex (str, cha, num) {
    var x = str.indexOf(cha)
    for (var i = 1; i < num; i++) {
      x = str.indexOf(cha, x + 1)
    }
    return x + 1
  },
  compareDate (item1, item2) {
    const time1 = item1.StartTimeStamp
    const time2 = item2.StartTimeStamp
    if (time1 < time2) {
      return -1
    } else if (time1 > time2) {
      return 1
    } else {
      return 0
    }
  },
  //    options = {
  // 	data:data,		data是接口返回的数据
  // 	isSame:true,	isSame表示数组值是否一样例如[{value:'Thomas',label:'Thomas'}]false时[{value:'1',label:'Thomas'}]
  //	valArray:['value','label'],	生成数组里面结构[{value:'Thomas',label:'Thomas'}]
  //  keyArray:['id','name']	根据接口返回里面的字段来获取相应的值
  // }
  changeArray (options) {
    const returnArray = []
    const array = options.data
    const itemType = Array.isArray(array)
    const { isSame } = options
    const valArray = options.valArray || ['value', 'label']
    const keyArray = options.keyArray || ['id', 'name']
    // 先判断数据是数组还是对象
    if (itemType) {
      // 判断数组里面的值是string还是object,分别处理.
      const dataType = typeof array[0]
      if (dataType === 'string') {
        // 判断是否生成值一样的数组
        if (isSame) {
          // 生成结构(例如value,label):[{value:'Thomas',label:'Thomas'}]
          array.forEach((item, index) => {
            var obj = {}
            valArray.forEach((itm, idx) => {
              obj[itm] = item
            })
            returnArray.push(obj)
          })
        } else {
          // 生成结构[{value:1,label:'Thomas'}],注意此方法不支持更改valArray里面的值。
          array.forEach((item, index) => {
            var obj = {}
            valArray.forEach((itm, idx) => {
              itm === 'value' ? (obj[itm] = index) : (obj[itm] = item)
            })
            returnArray.push(obj)
          })
        }
      } else if (isSame) {
        array.forEach((item, index) => {
          var obj = {}
          valArray.forEach((itm, idx) => {
            obj[itm] = item[keyArray[0]]
          })
          returnArray.push(obj)
        })
      } else {
        array.forEach((item, index) => {
          var obj = {}
          valArray.forEach((itm, idx) => {
            obj[itm] = item[keyArray[idx]]
          })
          returnArray.push(obj)
        })
      }
    }
    return returnArray
  },
  // 返回32位随机水
  return32Str (length = 32) {
    var chars = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z'
    ]
    var num = ''
    for (var i = 0; i < length; i++) {
      const id = parseInt(Math.random() * 61)
      num += chars[id]
    }
    return num
  },
  axios (method, url, data, callback) {
    axios({
      method,
      url,
      data: data || ''
    })
      .then(res => {
        if (res.status == 200) {
          if (res.data.errorCode) {
            if (res.data.errorCode == '0x0') {
              res.data.result ? callback(res.data.result) : callback(res.data)
            } else {
              const errorInfo =
                this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          } else {
            callback(res.data)
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  getHashParams (key) {
    const hashVal = window.location.hash.split('?')[1]
    if (!hashVal) return
    const hashArr = hashVal.split('&')
    for (let i = 0; i < hashArr.length; i++) {
      if (hashArr[i].split('=')[0] == key) {
        return hashArr[i].split('=')[1] || true
      }
    }
  },
  // 获取session
  getSession () {
    let _str = ''
    let session = ''
    const cookieArr = document.cookie.split(';')
    for (const v of cookieArr) {
      if (
        v
          .split('=')[0]
          .toLowerCase()
          .trim() === 'sid'
      ) {
        session = v.split('=')[1]
        break
      }
    }
    if (!session) {
      Bus.$emit('jumpLoginPage')
      return null
    }
    _str = session
    window.localStorage.setItem('channelSession', session)
    return _str
  },
  getQueryString (name, str, symbol) {
    str = str == null ? window.location.search.substr(1) : str
    symbol = symbol == null ? '&' : symbol
    var reg = new RegExp(
      `(^|${symbol})${name}=([^${symbol}]*)(${symbol}|$)`,
      'i'
    )
    var r = str.match(reg)
    if (r != null) return unescape(r[2])
    return null
  },
  getUTCTime (date) {
    // 返回UTC时间
    return date.getTime() + date.getTimezoneOffset() * 60000
  },
  timeFormat (time) {
    return time >= 0 && time < 10 ? `0${time}` : time
  },
  getDateTime (time) {
    // 避免方法undefined
    if (!(time && time.getFullYear)) {
      time = new Date()
    }
    var year = time.getFullYear()
    var month = this.timeFormat(time.getMonth() + 1)
    var day = this.timeFormat(time.getDate())
    var hour = this.timeFormat(time.getHours())
    var min = this.timeFormat(time.getMinutes())
    var s = this.timeFormat(time.getSeconds())
    return { year, month, day, hour, min, s }
  },
  getType (value) {
    return Object.prototype.toString.call(value).slice(8, -1)
  },
  getUrl (url) {
    return `/gatewayPlayoutUrl/tvu-playout${url}`
    // return '/tvucc' + url;
  },
  getDeviceExtraUrl (url) {
    const gatewayDeviceExtraUrl = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo.gatewayDeviceExtraUrl
    return `${window.location.protocol}//${gatewayDeviceExtraUrl}/device-extra/${url}`
  },
  // 时间格式
  DATE (date, fmt) {
    // 传入时间戳
    if (!date) {
      return ''
    }
    date = new Date(date * 1)
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
      )
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        const str = `${o[k]}`
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : `00${str}`.substr(str.length)
        )
      }
    }
    return fmt
  },
  /* 判断是否是内网IP */
  isInnerIPFn () {
    // 获取当前页面url
    var curPageUrl = window.location.href
    var reg1 = /(http|ftp|https|www):\/\//g // 去掉前缀
    curPageUrl = curPageUrl.replace(reg1, '')
    // console.log('curPageUrl-1  '+curPageUrl);

    var reg2 = /:+/g // 替换冒号为一点
    curPageUrl = curPageUrl.replace(reg2, '.')
    // console.log('curPageUrl-2  '+curPageUrl);

    curPageUrl = curPageUrl.split('.') // 通过一点来划分数组
    console.log(curPageUrl)

    var ipAddress = `${curPageUrl[0]}.${curPageUrl[1]}.${curPageUrl[2]}.${
      curPageUrl[3]
    }`

    var isInnerIp = false // 默认给定IP不是内网IP
    var ipNum = this.getIpNum(ipAddress)
    /**
     * 私有IP：A类  10.0.0.0    -10.255.255.255
     *       B类  172.16.0.0  -172.31.255.255
     *       C类  192.168.0.0 -192.168.255.255
     *       D类   127.0.0.0   -127.255.255.255(环回地址)
     **/
    var aBegin = this.getIpNum('10.0.0.0')
    var aEnd = this.getIpNum('10.255.255.255')
    var bBegin = this.getIpNum('172.16.0.0')
    var bEnd = this.getIpNum('172.31.255.255')
    var cBegin = this.getIpNum('192.168.0.0')
    var cEnd = this.getIpNum('192.168.255.255')
    var dBegin = this.getIpNum('127.0.0.0')
    var dEnd = this.getIpNum('127.255.255.255')
    isInnerIp =
      this.isInner(ipNum, aBegin, aEnd) ||
      this.isInner(ipNum, bBegin, bEnd) ||
      this.isInner(ipNum, cBegin, cEnd) ||
      this.isInner(ipNum, dBegin, dEnd)
    console.log(`是否是内网:${isInnerIp}`)
    return isInnerIp
  },
  getIpNum (ipAddress) {
    /* 获取IP数 */
    var ip = ipAddress.split('.')
    var a = parseInt(ip[0])
    var b = parseInt(ip[1])
    var c = parseInt(ip[2])
    var d = parseInt(ip[3])
    var ipNum = a * 256 * 256 * 256 + b * 256 * 256 + c * 256 + d
    return ipNum
  },
  isInner (userIp, begin, end) {
    return userIp >= begin && userIp <= end
  },
  getCookie (name) {
    let [arr, reg] = ['', new RegExp(`(^| )${name}=([^;]*)(;|$)`)]
    arr = document.cookie.match(reg)
    // return arr?unescape(arr[2]):'en-US';
    return arr ? unescape(arr[2]) : 'en'
  },
  dynamicLoadJs (url, callback, id) {
    var head = document.getElementsByTagName('body')[0]
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = id || ''
    script.src = url
    if (typeof callback == 'function') {
      script.onerror = () => {
        const parameter = 'failed'
        callback && callback(parameter)
      }
      script.onload = () => {
        if (
          !this.readyState ||
          this.readyState === 'loaded' ||
          this.readyState === 'complete'
        ) {
          const parameter = 'true'
          callback && callback(parameter)
          script.onload = null
          script.onreadystatechange = null
        }
      }
    }
    head.appendChild(script)
  },

  includeLinkStyle (url) {
    var link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = url
    document.getElementsByTagName('head')[0].appendChild(link)
  },
  // 时间转换
  // 2017 ===> 2017-12-31 23:59:59;
  // 2017-5 ===> 2017-5-31 23:59:59
  // timeString: 时间字符串
  // isStart: 是否开始时间，否,则是结束时间
  // separator: 字符串分隔符

  formatTime (timeString, isStart, separat) {
    if (!timeString) return
    var arr = []
    var target = 0
    var monthNum = ''
    var separator = ''

    separator = separat || '-'

    arr = timeString.split(separator)
    if (arr.length === 1) {
      // 年：2017
      if (isStart) {
        // 开始时间
        timeString = `${timeString}/01/01 00:00:00`
      } else {
        // 结束时间
        timeString = `${timeString}/12/31 23:59:59`
      }
    } else if (arr.length === 2) {
      // 年月:2017-05
      if (isStart) {
        timeString = `${timeString + separator}01 00:00:00`
      } else {
        monthNum = `${new Date(arr[0], arr[1], 0).getDate()}`
        timeString = `${timeString + separator + monthNum} 23:59:59`
      }
    } else if (arr.length === 3) {
      // 年月日:2017-05-25
      if (isStart) {
        timeString = `${timeString} 00:00:00`
      } else {
        timeString = `${timeString} 23:59:59`
      }
    } else {
      return false
    }
    target = new Date(timeString).getTime()
    return target
  },
  // 加密
  encryption (pid) {
    const index = Math.floor(pid / 2)
    const preNum = pid.slice(0, index)
    const afternum = pid.slice(index, 16)
    return btoa(`${afternum}_${preNum}`)
  },
  // 转换参数
  TransferParams (params) {
    let str = '?'
    for (const key in params) {
      str += `${key}=${params[key]}&`
    }
    return str.slice(0, str.length - 1)
  },
  ToTip (errorCode, type, deafaultTip) {
    // 提示方法
    /*
     *  lang=>对应的中英文翻译
     *  type=>提示类型
     *  errorCode=>错误代码
     *  deafaultTip=>默认的其它的提示或在此方法内找不到对应code的提示
     * */
    let messageText = toTipsObj[errorCode] ? toTipsObj[errorCode] : deafaultTip
    const warningType = type || 'warning'
    if (!messageText) {
      // 所有的提示都没有给
      messageText = 'lang.error'
      console.log("Don't give tips key => 没有给提示的关键字")
    }
    messageText = i18n.t(messageText)
    utilVue.$message({
      message: messageText,
      type: warningType
    })
  },
  loadMapJs (lang, fn) {
    if (lang == 'zh') {
      window.baiduMapCb = fn
      const { protocol } = window.location
      const mapKey =
        JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
          .baiduMapAccount || 'VZEEYKhypd8OFsR1GhGT4bsWcRaydc0n'
      // mapKey = "VZEEYKhypd8OFsR1GhGT4bsWcRaydc0n",
      const script = document.createElement('script')
      script.src = `${protocol}//api.map.baidu.com/api?v=2.0&ak=${mapKey}&callback=baiduMapCb`
      document.body.appendChild(script)
    } else {
      const { protocol } = window.location
      const loadZh = !!lang.includes('zh')
      const mapKey =
        JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
          .googleMapAccount || 'AIzaSyAmVG66-xSKTHviKU_9y42KsHNlt_jI3X4'
      // mapKey = "AIzaSyAmVG66-xSKTHviKU_9y42KsHNlt_jI3X4",
      const libraries = 'places'
      const cnJs = `${protocol}//maps.google.cn/maps/api/js?key=${mapKey}&libraries=${libraries}&language=cn`
      const enJs = `${protocol}//maps.googleapis.com/maps/api/js?key=${mapKey}&libraries=${libraries}&language=en`
      const keyUrl = loadZh ? cnJs : enJs
      const otherUrl = loadZh ? enJs : cnJs
      const keyId = loadZh ? 'googlemap_cnMap' : 'googlemap_enMap'
      const otherId = loadZh ? 'googlemap_enMap' : 'googlemap_cnMap'
      const labelId = 'googlemap_labelJs'
      const labelJsUrl = './reference/markerwithlabel.js'
      if (
        ($('#googlemap_cnMap').length > 0 && loadZh) ||
        ($('#googlemap_enMap').length > 0 && !loadZh)
      ) {
        fn()
      } else if (
        ($('#googlemap_cnMap').length > 0 && !loadZh) ||
        ($('#googlemap_enMap').length > 0 && loadZh)
      ) {
        window.history.go(0)
      } else {
        this.dynamicLoadJs(
          keyUrl,
          status => {
            if (status == 'true') {
              this.dynamicLoadJs(
                labelJsUrl,
                () => {
                  fn()
                },
                labelId
              )
            } else {
              this.dynamicLoadJs(
                otherUrl,
                status2 => {
                  if (status2 == 'true') {
                    this.dynamicLoadJs(
                      labelJsUrl,
                      () => {
                        fn()
                      },
                      labelId
                    )
                  } else {
                    utilVue.$message({
                      type: 'info',
                      message: i18n.t('lang.i18n_mapFailed')
                    })
                  }
                },
                otherId
              )
            }
          },
          keyId
        )
      }
    }
  },
  setPermissionTips (tipTag, langKey) {
    const ccTipObj = {
      mv: {
        zhName:
          '请联系技术支持人员购买此功能，然后你就可以监控并与任意设备通话了。',
        enName:
          'Currently you are not licensed for this feature, please contact support for more information.',
        ruName:
          'В данный момент у вас нет лицензии для использования этой функции. Для дополнительной информации, пожалуйста свяжитесь с технической поддержкой.'
      },
      bk: {
        zhName: '请联系技术支持开通有权限。',
        enName: 'Please contact support for authorization.',
        ruName:
          'Для авторизации, пожалуйста, свяжитесь с тезнической поддержкой.'
      },
      tk: {
        zhName:
          '请联系技术支持人员购买此功能，然后你就可以用TVU直播手机扫描或输入配对码与收发机完成配对。',
        enName:
          'Currently you are not licensed for this feature, please contact support for more information.',
        ruName:
          'В данный момент у вас нет лицензии для использования этой функции. Для дополнительной информации, пожалуйста свяжитесь с технической поддержкой.'
      },
      sh: {
        zhName:
          '请联系技术支持人员购买此功能，然后你就可以在社交媒体上分享视频了。',
        enName:
          'Currently you are not licensed for this feature, please contact support for more information.',
        ruName:
          'В данный момент у вас нет лицензии для использования этой функции. Для дополнительной информации, пожалуйста свяжитесь с технической поддержкой.'
      }
    }
    langKey = langKey || 'enName'
    const tipText = ccTipObj[tipTag]
      ? ccTipObj[tipTag][langKey]
      : ccTipObj.bk[langKey]
    if ($(window).width() > 1024) {
      if (
        $('#headerNoAuthorityBg').length > 0 ||
        $('#headerNoAuthorityTip').length > 0
      ) {
        $('#headerNoAuthorityBg,#headerNoAuthorityTip').remove()
        if (tipTimers) {
          clearTimeout(tipTimers)
        }
      }
      const permissionObj = `<div id="headerNoAuthorityBg"></div><div id="headerNoAuthorityTip"><p>${tipText}</p></div>`
      $('body').append(permissionObj)
      window.tipTimers = setTimeout(() => {
        if (
          $('#headerNoAuthorityBg').length > 0 ||
          $('#headerNoAuthorityTip').length > 0
        ) {
          $('#headerNoAuthorityBg,#headerNoAuthorityTip').remove()
          clearTimeout(tipTimers)
        }
      }, 5000)
      $('#headerNoAuthorityBg').click(() => {
        $('#headerNoAuthorityBg,#headerNoAuthorityTip').remove()
        if (tipTimers) {
          clearTimeout(tipTimers)
        }
      })
    } else {
      this.$message({
        type: 'info',
        message: tipText
      })
    }
  },
  // js模拟重载
  heavyLoad (obj, key, paramLength, fn, target) {
    obj[`${key}${paramLength}`] = fn
    obj[key] = function () {
      obj[`${key}${arguments.length}`].apply(target, arguments)
    }
  },
  // 获取间隔时间
  getIntervalTime (start, end, type) {
    start = typeof start == 'object' ? start.getTime() : start
    end = typeof end == 'object' ? end.getTime() : end
    const interval = end - start
    if (interval <= 0) {
      return '00:00:00'
    }
    const d = Math.floor(interval / (1000 * 60 * 60 * 24))
    const h = Math.floor((interval / (1000 * 60 * 60)) % 24) + d * 24
    const m = Math.floor((interval / (1000 * 60)) % 60)
    let s = Math.floor((interval / 1000) % 60)
    if (type) {
      s = Math.ceil((interval / 1000) % 60)
    }
    return `${this.timeFormat(h)}:${this.timeFormat(m)}:${this.timeFormat(s)}`
  },
  // 禁止输入特殊字符
  cleanSpelChar (val) {
    if (/["'<>%;)(&+]/.test(val)) {
      val = val.replace(/["'<>%;)(&+]/, '')
    }
    return val
  },
  // 百度gps坐标批量转换，points:待转换的坐标数组，call：转换完成后的回调
  tranlatePoint (points, call) {
    var tempArr = [] // 转换完成后的坐标数组
    var total = 0 // 总记录数
    var groupCount = 0 // 每次转十条
    if (points.length % 10 > 0) {
      groupCount = Math.floor(points.length / 10) + 1
    } else {
      groupCount = points.length / 10
    }
    for (let i = 0; i < groupCount; i++) {
      // 外层循环，有多少组十条
      var pos = []
      for (var j = 0; j < 10; j++) {
        // 内层循环，每组十条
        if (total < points.length) {
          // 不超过总记录数结束
          var point = new BMap.Point(
            points[i * 10 + j].lng,
            points[i * 10 + j].lat
          )
          pos.push(point)
        }
        total++
      }
      var convertor = new BMap.Convertor()
      convertor.translate(pos, 3, 5, data => {
        if (data.status === 0) {
          for (var k = 0; k < data.points.length; k++) {
            tempArr.push(data.points[k])
          }
          if (i == groupCount - 1) {
            call(tempArr)
          }
        }
      })
    }
  },
  // 获取当前时区的夏令时
  DisplayDstSwitchDates (year) {
    // var year = new Date('2022').getYear()
    if (year < 1000) year += 1900
    let firstSwitch = 0
    let secondSwitch = 0
    let lastOffset = 99

    // 遍历当前年份的每个月
    for (let i = 0; i < 12; i++) {
      // 获取当月的时区值
      const newDate = new Date(Date.UTC(year, i, 0, 0, 0, 0, 0))
      const tz = (-1 * newDate.getTimezoneOffset()) / 60
      // 发生timzezone变化时捕获
      if (tz > lastOffset) {
        firstSwitch = i - 1
      } else if (tz < lastOffset) {
        secondSwitch = i - 1
      }

      lastOffset = tz
    }

    // 找出一分钟前发生的日期/时间
    // 发生夏令时调整
    const secondDstDate = this.FindDstSwitchDate(year, secondSwitch)
    const firstDstDate = this.FindDstSwitchDate(year, firstSwitch)

    if (firstDstDate == null || secondDstDate == null) {
      return {
        isDst: false
      }
    } else {
      secondDstDate.lastHour = secondDstDate.tmpDate.getTime() - 3600000
      secondDstDate.startTime = secondDstDate.tmpDate.getTime()
      secondDstDate.endTime = secondDstDate.tmpDate.getTime() + 3600000
      firstDstDate.lastHour = firstDstDate.tmpDate.getTime() - 3600000
      firstDstDate.startTime = firstDstDate.tmpDate.getTime()
      firstDstDate.endTime = firstDstDate.tmpDate.getTime() + 3600000
      return {
        firstDstDate,
        secondDstDate,
        isDst: true
      }
    }
  },
  FindDstSwitchDate (year, month) {
    // 设置开始日期
    const baseDate = new Date(Date.UTC(year, month, 0, 0, 0, 0, 0))
    let changeMinute = -1
    const baseOffset = (-1 * baseDate.getTimezoneOffset()) / 60
    let dstDate

    // 循环查找时区调整发生的确切日期
    for (let day = 0; day < 50; day++) {
      let tmpDate = new Date(Date.UTC(year, month, day, 0, 0, 0, 0))
      let tmpOffset = (-1 * tmpDate.getTimezoneOffset()) / 60

      // 检查时区是否从一天到下一天发生了变化
      if (tmpOffset != baseOffset) {
        let minutes = 0

        // 备份一天，收回偏移量
        tmpDate = new Date(Date.UTC(year, month, day - 1, 0, 0, 0, 0))
        tmpOffset = (-1 * tmpDate.getTimezoneOffset()) / 60

        // 计算时区发生变化之前的分钟数
        while (changeMinute == -1) {
          tmpDate = new Date(Date.UTC(year, month, day - 1, 0, minutes, 0, 0))
          tmpOffset = (-1 * tmpDate.getTimezoneOffset()) / 60

          // 计算时区发生变化之前的分钟数
          // occurs
          if (tmpOffset != baseOffset) {
            // 备份一分钟以获取日期/时间
            // 在时区改变发生之前
            tmpOffset = new Date(
              Date.UTC(year, month, day - 1, 0, minutes - 1, 0, 0)
            )
            changeMinute = minutes
            break
          } else {
            minutes++
          }
        }

        // 添加一个月（用于显示），因为 JavaScript 计数
        // 从 0 到 11 的月份
        dstDate = tmpOffset.getMonth() + 1

        // 根据需要填充月份
        if (dstDate < 10) dstDate = `0${dstDate}`

        // 添加日期和年份
        dstDate += `/${tmpOffset.getDate()}/${year} `

        // 获取时间戳
        tmpDate = new Date(Date.UTC(year, month, day - 1, 0, minutes, 0, 0))
        // console.log(tmpDate, tmpDate.toTimeString())
        dstDate += tmpDate.toTimeString().split(' ')[0]
        return {
          tmpDate,
          dstDate
        }
      }
    }
  }
}

export default Tool
